module.exports = __webpack_public_path__ + "media/flags/ck-aa585998.svg";